import { clientLog } from '../logs';
import { PushJSLog } from './PushJSLog';
import { logDebugConsole } from '../console/DebugConsole';
import { LEVEL } from '../LEVEL';

const loghash = Math.random()
    .toString(36)
    .replace(/[^a-z]+/g, '')
    .substr(0, 5);

export const pushJSLogger = {
    error(message, ...args) {
        console.error('[push-js-client]', message, ...args);
        logDebugConsole(message, 'error');
        clientLog(
            PushJSLog({
                message: `[${loghash}] ${message}`,
                data: { ...args },
                level: LEVEL.ERROR
            })
        );
    },
    info(message, ...args) {
        console.log('[push-js-client]', message, ...args);
        logDebugConsole(message, 'info');
        clientLog(
            PushJSLog({
                message: `[${loghash}] ${message}`,
                data: { ...args },
                level: LEVEL.INFO
            })
        );
    },
    log(message, ...args) {
        console.log('[push-js-client]', message, ...args);
        logDebugConsole(message, 'info');
        clientLog(
            PushJSLog({
                message: `[${loghash}] ${message}`,
                data: { ...args },
                level: LEVEL.INFO
            })
        );
    },
    warn(message, ...args) {
        console.warn('[push-js-client]', message, ...args);
        logDebugConsole(message, 'warn');
        clientLog(
            PushJSLog({
                message: `[${loghash}] ${message}`,
                data: { ...args },
                level: LEVEL.WARN
            })
        );
    },
    trace(message, ...args) {
        logDebugConsole(message, 'trace');
    }
};
